/* eslint-disable no-loop-func */
import { Box, Typography, useMediaQuery, LinearProgress } from '@mui/material';
import React, { useEffect, useState, useContext, useCallback } from 'react';
import AuthApis from '../hepler/authApis.service';
import './AccountDiscovery.styles.css';
import AccountDiscoveryContainer from './Discovery/AccountDiscoveryContainer';
import FilteredAccountNotFoud from './FilteredAccountNotFoud';
import FipDiscoveryLoader from './Discovery/FipDiscoveryLoader';
import { toast } from 'react-toastify';
import { useTheme } from '@mui/material';
import DialogBox from './Dialog Box/Dialog Box';
import VerifyDetailsDOB from './Dialog Box/VerifyDetailsDOB';
import SetTheme from './common/SetTheme';
import { trackEvent } from '../utils/tracking.utils';
import {
	handleFipDiscovery,
	updateAccountDiscoveryState,
} from '../utils/accountDiscovery.utils';
import { areAccountRestrictionsSatisfied } from '../utils/targetedAccounts.utils';
import StepperContext from './Context/StepperContext';
import { useTranslation } from '../hooks/useTranslation';

function AccountDiscovery(props) {
	const { t } = useTranslation();
	const fipExclusionFromJourney = global?.sdkOptions?.fipExclusionFromJourney;
	const { nextStep } = useContext(StepperContext);
	const theme = useTheme();
	const mobileScreen = useMediaQuery(theme.breakpoints.down('md'));

	// Check for dark theme
	const isDark = props.customDetails?.darkTheme === true || theme.palette.mode === 'dark';
	
	const [accountState, setAccountState] = useState({
		isProceed: true,
		discoveredAccounts: [],
		selectedAccounts: [],
		linkedAccounts: [],
		linkedAccountsFull: [],
		isResend: true,
		isLoding: global.isFlowChange === 'true' ? false : true,
		isDiscovering: global.isFlowChange === 'true' ? true : false,
		selectedBank: null,
		isSkip: false,
		isDisable: false,
		consentDetails: global.consentList
			? global.consentList
			: props?.location?.state?.data,
		noDiscoveredAccounts: null,
	});
	
	const [retryCount, setRetryCount] = useState(0);
	const [maxRetries] = useState(Math.min(global.sdkOptions?.maxRetries ?? 1, 3));
	const [isPanRequired, setIsPanRequired] = useState(
		global?.pan === 'Y' ? false : true
	);
	const [isDobRequired, setIsDobRequired] = useState(
		global?.dob === 'Y' ? false : true
	);
	
	const [openDOB, setOpenDOB] = useState(false);
	const [dob, setDob] = useState(global?.dob);
	const [pan, setPan] = useState(global?.pan);
	const authApis = new AuthApis();

	// Helper function to get missing targeted accounts
	const getMissingTargetedAccounts = useCallback(() => {
		if (!global.redirectAccountRestrictions || !Array.isArray(global.redirectAccountRestrictions)) {
			return [];
		}
		
		// Get all discovered accounts flattened
		const allDiscoveredAccounts = accountState.discoveredAccounts.flatMap(
			fip => fip.discoveredAccounts || []
		);
		
		// Find targeted accounts that are not in discovered accounts
		const missingAccounts = global.redirectAccountRestrictions.filter(targetedAcc => {
			return !allDiscoveredAccounts.some(discoveredAcc => 
				discoveredAcc.FIType === targetedAcc.fiType &&
				discoveredAcc.accType === targetedAcc.accType &&
				discoveredAcc.maskedAccNumber?.slice(-4) === targetedAcc.maskedAccNumber
			);
		});
		
		return missingAccounts;
	}, [accountState.discoveredAccounts]);

	useEffect(() => {
		checkIdentifiers();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const getLinkedAcc = () => {
		props.updateLoader(false);
		authApis.getLinkedAccounts().then((res) => {
			if (!res) {
				toast.error(t('errors.general.somethingWentWrong'));
				props.updateLoader(false);
			}
			if (res?.status === 'SUCCESS') {
			let linkedacc = res.LinkedAccounts.map((el) => el.accRefNumber);
			let linkedaccFull = res.LinkedAccounts.map((el) => ({
				maskedAccNumber: el.maskedAccNumber,
				FIType: el.FIType,
				accType: el.accType,
				fipId: el.fipId,
				accRefNumber: el.accRefNumber,
				linkRefNumber: el.linkRefNumber,
				fipName: el.fipName,
			}));

				setAccountState((prevState) => ({
					...prevState,
					linkedAccounts: [...accountState.linkedAccounts, ...linkedacc],
					linkedAccountsFull: [
						...accountState.linkedAccountsFull,
						...linkedaccFull,
					],
				}));
				if (props.match.params.fid) {
					discoverAccount(linkedaccFull);
				} else {
					if (!global.isAddAccount) {
						props.updateLoader(false);
						props.history.push({
							pathname: `/payment-consent`,
							state: {
								data: res.LinkedAccounts,
							},
						});
						nextStep(2);
					} else {
						discoverAccount();
					}
				}
			} else {
				if (res?.status === 'FAILURE') {
					if (
						res?.code === undefined ||
						res?.code === null ||
						res?.code === ''
					) {
						toast.error(res?.message);
					} else {
						toast.error(t(`errors.code.${res.code}`));
					}
					setTimeout(() => {
						props.history.push({
							pathname: `/consent-status`,
							state: {
								status: 'Consent denied',
								statusCode: 20,
							},
						});
					}, 10000);
				}
				if (props.match.params.fid) {
					discoverAccount();
				} else {
					props.updateLoader(false);
					props.history.push('/payment-consent');
					nextStep(2);
				}
			}
		});
	};

	const getFipIdentifiersInfo = async (fid) => {
		const fipIdentifiers = {};
		const fipIdentifiersTypes = new Set();
		await authApis.fipDetails(fid).then((res) => {
			if (res?.status === 'SUCCESS') {
				res?.FipDetails[0]?.fipFiTypeIdentifiers.forEach((x) => {
					x?.identifiers.forEach((id) => {
						fipIdentifiers[id.type] = id.category;
						fipIdentifiersTypes.add(id.type);
					});
				});
			} else if (
				res?.status === 'FAILURE' &&
				res?.message === 'Session Error.'
			) {
				toast.error(t('errors.session.error'));
			}
		});
		return fipIdentifiers;
	};

	const checkIdentifiers = async () => {
		if (!props.match.params.fid) {
			return getLinkedAcc();
		}
		const fips = props.match.params.fid?.split(',');
		const fipIdentifiersTypes = [];
		for (const fid of fips) {
			fipIdentifiersTypes.push(
				...Object.keys(await getFipIdentifiersInfo(fid))
			);
		}
		if (
			isPanRequired &&
			isDobRequired &&
			fipIdentifiersTypes.includes('DOB') &&
			fipIdentifiersTypes.includes('PAN')
		) {
			setIsDobRequired(true);
			setIsPanRequired(true);
			setOpenDOB(true);
		} else if (isPanRequired && fipIdentifiersTypes.includes('PAN')) {
			setIsPanRequired(true);
			setIsDobRequired(false);
			setOpenDOB(true);
		} else if (isDobRequired && fipIdentifiersTypes.includes('DOB')) {
			setIsDobRequired(true);
			setIsPanRequired(false);
			setOpenDOB(true);
		} else {
			getLinkedAcc();
		}
	};

	const handleDOB = () => {
		setOpenDOB(false);
		getLinkedAcc();
	};

	const discoverAccount = async (linkedaccFull = [], fipId, phoneNumber) => {
		// Clear swap flag when starting new discovery
		delete global.hasSwappedAccounts;
		
		linkedaccFull =
			linkedaccFull.length > 0
				? linkedaccFull
				: accountState.linkedAccountsFull;

		let exclusionList = [];
		try {
			if (fipExclusionFromJourney) {
				exclusionList = JSON.parse(fipExclusionFromJourney);
			}
		} catch (error) {
			console.error('Failed to parse fipExclusionFromJourney:', error);
		}

		const rawFips = fipId ?? props.match.params.fid?.split(',');
		const fips = Array.isArray(rawFips)
			? rawFips.filter((id) => !exclusionList.includes(id))
			: rawFips;

		if (fips.length === 0) {
			props.history.push(
				`/home/?number=${props.match.params?.number}&isAddAccount=${true}`
			);
		}
		phoneNumber = phoneNumber ? phoneNumber : props.match.params.number;

		if (props.match.params.fid?.includes(',')) {
			trackEvent('MULTIPLE_FIP_DISCOVERY', {
				totalFips: fips.length,
				count: fips.length,
			});
		}

		// Create a map to track pending discoveries
		const pendingDiscoveries = new Map();

		// Start all FIP discoveries without waiting
		fips.forEach(async (fid) => {
			try {
				const fipIdentifiersInfo = await getFipIdentifiersInfo(fid);
				const fipData = await handleFipDiscovery({
					fid,
					fipIdentifiersInfo,
					phoneNumber,
					pan,
					dob,
					isPanRequired,
					isDobRequired,
					linkedaccFull,
					authApis,
					pendingDiscoveries,
				});
				setAccountState((prevState) => {
					const updatedState = updateAccountDiscoveryState(
						prevState,
						fipData,
						phoneNumber,
						props.history,
						pendingDiscoveries
					);

					// Check account restrictions satisfaction if they exist
					if (
						global.redirectAccountRestrictions &&
						props?.location?.state?.data &&
						updatedState.linkedAccountsFull
					) {
						const allRestrictionsSatisfied = areAccountRestrictionsSatisfied(
							updatedState.discoveredAccounts,
							updatedState.linkedAccountsFull
						);

						if (allRestrictionsSatisfied && pendingDiscoveries.size === 0) {
							props.history.push(`/payment-consent`);
						}
					}
					if (global.isFlowChange === 'true' && pendingDiscoveries.size === 0) {
						props.history.push({
							pathname: `/payment-consent`,
							state: {
								data: updatedState.linkedAccountsFull,
								discoveredAccounts: updatedState.discoveredAccounts,
							},
						});
					}
					return updatedState;
				});
			} catch (error) {
				console.error(`Error in FIP discovery for ${fid}:`, error);
				toast.error(t('errors.general.somethingWentWrong'));
			}
		});
	};

	const handleBack = () =>
		props.history.push(
			`/home/?number=${props.match.params?.number}&isAddAccount=${true}`
		);

	const setTheme = (theme) => {};

	const handleClose = (event, reason) => {
		if (reason && reason === 'backdropClick') {
			return;
		}
		setOpenDOB(false);
		getLinkedAcc();
	};

	const handleRetryDiscovery = () => {
		if (retryCount >= maxRetries) {
			toast.error(t('accountDiscovery.errors.maxRetriesReached'));
			return;
		}
		
		setRetryCount(prev => prev + 1);
		
		// Get unique FIP IDs from missing accounts
		const missingAccounts = getMissingTargetedAccounts();
		const fipsToRetry = [...new Set(missingAccounts.map(acc => acc.fipId))];
		
		// Keep already discovered accounts, only reset for missing FIPs
		setAccountState((prevState) => ({
			...prevState,
			isDiscovering: true,
			noDiscoveredAccounts: null,
		}));

		// Re-trigger discovery only for FIPs with missing accounts
		const phoneNumber = props.match.params.number;

		// Re-run discovery only for missing FIPs
		discoverAccount(accountState.linkedAccountsFull, fipsToRetry, phoneNumber);
	};

	useEffect(() => {
		if (props?.updateInitialLoader) {
			props.updateInitialLoader(false);
		}
		
		// Cleanup on unmount
		return () => {
			if (global.hasHandledRetryExhaustion) {
				delete global.hasHandledRetryExhaustion;
			}
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	// Handle account swap for allowAnyAccountOnNoMatch OR after retry exhaustion
	useEffect(() => {
		const isRetryExhausted = retryCount >= maxRetries;
		const missingAccounts = getMissingTargetedAccounts();
		const totalTargetedAccounts = global.redirectAccountRestrictions?.length || 0;
		const isCompleteNoMatch = missingAccounts.length === totalTargetedAccounts && totalTargetedAccounts > 0;
		const hasMissingAccounts = missingAccounts.length > 0;
		const hasDiscoveredAccounts = accountState.discoveredAccounts.length > 0;
		
		// Check if there are ANY discovered accounts (including non-targeted ones)
		const hasAnyDiscoveredAccounts = accountState.discoveredAccounts.some(fip => 
			(fip.allDiscoveredAccounts && fip.allDiscoveredAccounts.length > 0) || 
			fip.discoveredAccounts.length > 0
		);
		
		// After retry exhaustion, handle flow based on what accounts are available
		if (
			isRetryExhausted &&
			global.redirectAccountRestrictions &&
			!accountState.isDiscovering &&
			!accountState.isLoding &&
			!global.hasHandledRetryExhaustion
		) {
			global.hasHandledRetryExhaustion = true;
			
			// Scenario 1: Partial match - show matched accounts, let user proceed
			if (!isCompleteNoMatch && hasDiscoveredAccounts) {
				// Keep the matched accounts, allow user to proceed or add more
				delete global.showingFilteredAccountNotFound;
				return;
			}
			
		// Scenario 2: No match but other accounts exist - show those accounts (if allowed)
		if (isCompleteNoMatch && hasAnyDiscoveredAccounts) {
			// If adding accounts is disabled, keep modal open (don't swap accounts)
			// BUT: If allowAnyAccountOnNoMatch is true, allow swapping
			if (global.sdkOptions?.disabledAddNew === 'true' && 
				global.sdkOptions?.allowAnyAccountOnNoMatch !== 'true') {
				// Keep showing the modal, user cannot proceed
				return;
			}
			
			// Clear modal flag and let the code fall through to the swap logic below
			delete global.showingFilteredAccountNotFound;
			// Don't return here - let the swap logic handle the actual swapping
		}
			
		// Scenario 3: No accounts at all - redirect to FIP selection (if allowed)
		if (!hasAnyDiscoveredAccounts) {
			// If adding accounts is disabled, keep modal open (don't redirect)
			// BUT: If allowAnyAccountOnNoMatch is true, allow redirecting
			if (global.sdkOptions?.disabledAddNew === 'true' && 
				global.sdkOptions?.allowAnyAccountOnNoMatch !== 'true') {
				// Keep showing the modal, user cannot proceed
				return;
			}
			
			delete global.redirectAccountRestrictions;
			delete global.showingFilteredAccountNotFound;
			global.isAddAccount = true;
			props.history.push('/home');
			return;
		}
		}
		
	// Handle account swap for allowAnyAccountOnNoMatch OR when disabledAddNew is not true
	// When retry is exhausted and no match found, show all accounts (unless adding new is disabled)
	if (
		global.redirectAccountRestrictions &&
		!accountState.isDiscovering &&
		!accountState.isLoding &&
		hasAnyDiscoveredAccounts && // Check for ANY accounts, not just filtered ones
		!global.hasSwappedAccounts && // Prevent multiple swaps
		!global.userClickedAddMore && // Don't swap if user manually clicked "Add More"
		(global.sdkOptions?.allowAnyAccountOnNoMatch === 'true' || global.sdkOptions?.disabledAddNew !== 'true')
	) {
		// Swap accounts when:
		// 1. allowAnyAccountOnNoMatch is true - swap immediately on COMPLETE no match only (not partial)
		// 2. OR after retry exhaustion if disabledAddNew is not true
		const shouldSwapImmediately = global.sdkOptions?.allowAnyAccountOnNoMatch === 'true' && isCompleteNoMatch;
		const shouldSwapAfterRetries = isRetryExhausted && (isCompleteNoMatch || hasMissingAccounts);
		const shouldSwap = shouldSwapImmediately || shouldSwapAfterRetries;

		if (shouldSwap) {
			// Set flag to prevent multiple swaps
			global.hasSwappedAccounts = true;
			
			// Clear the restriction flag so it behaves like normal discovery
			delete global.redirectAccountRestrictions;
			delete global.showingFilteredAccountNotFound;
			
		// Swap filtered accounts with all accounts (unfiltered)
		setAccountState((prevState) => {
			const updatedDiscoveredAccounts = prevState.discoveredAccounts
				.map(fip => {
					return {
						...fip,
						discoveredAccounts: fip.allDiscoveredAccounts || fip.discoveredAccounts
					};
				})
				.filter(fip => {
					// Only filter out FIPs with 0 accounts
					// Keep FIPs with linked accounts (same as normal journey)
					return fip.discoveredAccounts.length > 0;
				});
			
			return {
				...prevState,
				discoveredAccounts: updatedDiscoveredAccounts,
				selectedAccounts: [],
				noDiscoveredAccounts: null
			};
		});
		}
	}
	}, [accountState.isDiscovering, accountState.isLoding, accountState.discoveredAccounts, retryCount, maxRetries, getMissingTargetedAccounts, props.history, t]);
	return (
		<>
			<SetTheme customDetails={props.customDetails} setTheme={setTheme} />

			{/* Loader for isFlowChange === 'true' */}
			{accountState.isDiscovering && global.isFlowChange === 'true' && (
				<FipDiscoveryLoader
					fipIds={props.match.params.fid?.split(',') || []}
					customDetails={props.customDetails}
				/>
			)}

			{accountState.isDiscovering && global.isFlowChange !== 'true' && (
				<Box
					sx={{
						position: 'fixed',
						top: 0,
						left: 0,
						right: 0,
						zIndex: 9999,
						backgroundColor: 'white',
					}}
				>
					<LinearProgress
						color="primary"
						sx={{
							height: 4,
							backgroundColor: 'rgba(0, 0, 0, 0.1)',
							'& .MuiLinearProgress-bar': {
								transition: 'transform 0.4s linear',
								backgroundColor: theme.palette.primary.main,
							},
						}}
					/>
				</Box>
			)}
		{/* Show FilteredAccountNotFoud if no accounts or partial match in targeted mode */}
		{(() => {
			const missingAccounts = getMissingTargetedAccounts();
			const hasMissingAccounts = missingAccounts.length > 0;
		const totalTargetedAccounts = global.redirectAccountRestrictions?.length || 0;
		// Complete no match = ALL targeted accounts are missing (even if other accounts exist)
		const isCompleteNoMatch = missingAccounts.length === totalTargetedAccounts && totalTargetedAccounts > 0;
		
		// If allowAnyAccountOnNoMatch is true:
		// - After retry exhaustion with complete no match → don't show modal (swap handled in useEffect)
		// - After retry exhaustion with partial match → still show modal
		const isRetryExhausted = retryCount >= maxRetries;
		if (
			global.sdkOptions?.allowAnyAccountOnNoMatch === 'true' &&
			global.redirectAccountRestrictions &&
			isRetryExhausted &&
			isCompleteNoMatch // Only skip modal on complete no match, not partial
		) {
			return null;
	}
	
	// If disabledAddNew is true and it's a complete no match after retry exhaustion, keep modal open
	// BUT: If allowAnyAccountOnNoMatch is true and complete no match, don't show modal (allow swapping)
	const shouldKeepModalOpenAfterRetry = global.sdkOptions?.disabledAddNew === 'true' && 
		!(global.sdkOptions?.allowAnyAccountOnNoMatch === 'true' && isCompleteNoMatch) && 
		isRetryExhausted && 
		isCompleteNoMatch;
	
	const shouldShowFilteredNotFound = !accountState.isDiscovering &&
		!accountState.isLoding &&
		global.redirectAccountRestrictions &&
		hasMissingAccounts &&
		!isRetryExhausted && // Show modal during retries
		!global.userClickedAddMore && // Don't show if user clicked "Add More"
		!global.hasReachedConsent && // Don't show if user already reached consent page
		!(global.sdkOptions?.allowAnyAccountOnNoMatch === 'true' && isCompleteNoMatch); // Don't show only on complete no match if allowAnyAccountOnNoMatch is enabled
		
	// Special case: After retry exhaustion, keep modal open if disabledAddNew and complete no match
	const shouldShowModalAfterExhaustion = isRetryExhausted && shouldKeepModalOpenAfterRetry;
	
	const finalShouldShowModal = shouldShowFilteredNotFound || shouldShowModalAfterExhaustion;
		
		return finalShouldShowModal ? (
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'center',
					flexDirection: { xs: 'column', sm: 'column', md: 'row' },
					minHeight: '100vh',
					alignItems: 'center',
					pt: { xs: 0, md: '2rem' },
					backgroundColor: isDark ? '#161616' : theme.palette.primary.light,
				}}
			>
				<FilteredAccountNotFoud
					{...props}
					accountState={accountState}
					missingAccounts={missingAccounts}
					handleRetryDiscovery={handleRetryDiscovery}
					retryCount={retryCount}
					maxRetries={maxRetries}
				/>
			</Box>
		) : null;
		})()}
		
	{/* Show normal discovery container */}
	{(() => {
		const missingAccounts = getMissingTargetedAccounts();
		const isRetryExhausted = retryCount >= maxRetries;
		const totalTargetedAccounts = global.redirectAccountRestrictions?.length || 0;
		const isCompleteNoMatch = missingAccounts.length === totalTargetedAccounts && totalTargetedAccounts > 0;
		
		// Don't show container if disabledAddNew is true and it's a complete no match after retry exhaustion
		// BUT: If allowAnyAccountOnNoMatch is true and complete no match, show container (allow swapping)
		// If partial match, keep modal open regardless
		const shouldKeepModalOpen = global.sdkOptions?.disabledAddNew === 'true' && 
			!(global.sdkOptions?.allowAnyAccountOnNoMatch === 'true' && isCompleteNoMatch) && 
			isRetryExhausted && 
			isCompleteNoMatch;
		
		const shouldShowNormalContainer = 
			!global.redirectAccountRestrictions || 
			missingAccounts.length === 0 || 
			accountState.isDiscovering || 
			accountState.isLoding ||
			(isRetryExhausted && !shouldKeepModalOpen) || // Show container after retries exhausted (unless modal should stay open)
			global.userClickedAddMore; // Show container if user clicked "Add More"
			
	return shouldShowNormalContainer ? (
	<Box
		sx={{
			display: 'flex',
			justifyContent: { xs: 'start', md: 'center' },
			flexDirection: { xs: 'column', sm: 'column', md: 'row' },
			minHeight: mobileScreen ? 'auto' : '100vh',
			alignItems: 'start',
			pt: accountState.isDiscovering ? '4px' : 0,
		}}
	>
					{!accountState.isLoding ? (
						<AccountDiscoveryContainer
							{...props}
							setAccountState={setAccountState}
							discoverAccount={discoverAccount}
							accountState={accountState}
							handleBack={handleBack}
							handleRetryDiscovery={handleRetryDiscovery}
							retryCount={retryCount}
							maxRetries={maxRetries}
						/>
					) : (
					props.match.params.fid && (
						<>
							{!openDOB ? (
								<Box
									sx={{
										flex: 2,
										display: 'flex',
										alignItems: 'center',
										flexDirection: 'column',
										justifyContent: mobileScreen ? 'center' : 'center',
										minHeight: '100vh',
										minWidth: { xs: '100vw', md: 'auto' },
										background: isDark
											? '#161616'
											: theme.palette.primary.light,
										color: isDark ? '#FFFFFF' : '#000000',
									}}
								>
									<Typography
										sx={{
											fontSize: '1.25rem',
											fontWeight: 900,
											mb: '0.4rem',
											color: isDark ? '#FFFFFF' : '#000000',
										}}
									>
										{t('accountDiscovery.messages.discoveryLoadingHeading')}
									</Typography>
									<Typography
										sx={{
											fontSize: '1rem',
											mb: '1.5rem',
											color: isDark ? '#7A8185' : '#81858F',
										}}
									>
										{t('accountDiscovery.messages.discoveryLoadingSubHeading')}
									</Typography>
									<div className="dots-5"></div>
								</Box>
							) : (
								<Box
									sx={{
										flex: 2,
										display: 'flex',
										alignItems: 'center',
										flexDirection: 'column',
										justifyContent: mobileScreen ? 'start' : 'center',
										minHeight: '100vh',
										minWidth: { xs: '100vw', md: 'auto' },
										background: isDark
											? '#161616'
											: theme.palette.primary.light,
										color: isDark ? '#FFFFFF' : '#000000',
										pt: mobileScreen ? '2rem' : 'none',
									}}
								/>
							)}
						</>
					)
				)}
				</Box>
			) : null;
		})()}
			<DialogBox
				open={openDOB}
				handleClose={handleClose}
				title={t('common.messages.verifyYourDetails')}
				subTitle={t('common.messages.pandDobDetails')}
				boxPadding="1.25rem"
				subTitleMaxWidth="80%"
			>
				<VerifyDetailsDOB
					handleClick={handleDOB}
					date={dob}
					setDate={setDob}
					pan={pan}
					setPan={setPan}
					isPanRequired={isPanRequired}
					isDobRequired={isDobRequired}
				/>
			</DialogBox>
			{accountState.isDiscovering && global.isFlowChange !== 'true' && (
				<Box
					sx={{
						position: 'fixed',
						bottom: 0,
						left: 0,
						right: 0,
						background: isDark
							? 'rgba(22, 22, 22, 0.95)'
							: 'rgba(255, 255, 255, 0.95)',
						color: isDark ? '#FFFFFF' : '#000000',
						padding: '1rem',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						gap: '1rem',
						boxShadow: isDark
							? '0 -2px 10px rgba(0, 0, 0, 0.3)'
							: '0 -2px 10px rgba(0, 0, 0, 0.1)',
						zIndex: 1000,
					}}
				>
					<Typography
						variant="body2"
						sx={{ color: isDark ? '#FFFFFF' : 'inherit' }}
					>
						{t('accountDiscovery.messages.discoveringAccountsFips')}
					</Typography>
					<Box
						sx={{
							width: 20,
							height: 20,
							border: '2px solid #f3f3f3',
							borderTop: '2px solid #3498db',
							borderRadius: '50%',
							animation: 'spin 1s linear infinite',
							'@keyframes spin': {
								'0%': { transform: 'rotate(0deg)' },
								'100%': { transform: 'rotate(360deg)' },
							},
						}}
					/>
				</Box>
			)}
		</>
	);
}

export default AccountDiscovery;
